// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { PortletMetadata, ItemLayout, PortletLayout, PortletType, PortletContainerStatus, PortletContainerAdminEditView } from "../schema";

export function serialize_PortletContainerAdminEditView(obj: PortletContainerAdminEditView): string {
  const serialized = ((value: {
    customPortlets: PortletMetadata[];
    customized: boolean;
    defaultPortlets: PortletMetadata[];
    language: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr";
    portletContainerId: number;
    showDefaults: boolean;
    status: PortletContainerStatus;
  }): unknown => {
    return {
      customPortlets: ((value: PortletMetadata[]): unknown => {
        return value.map(
          (value: {
            custom: boolean;
            defaultFilterAllLanguages: boolean;
            embedSortingFiltering: boolean;
            hideTitle: boolean;
            itemCount: number;
            itemLayout: ItemLayout;
            name: string;
            portletId: number;
            portletLayout: PortletLayout;
            subType: string | null;
            subtitle: string;
            title: string;
            type: PortletType;
          }): unknown => {
            return {
              custom: ((value: boolean): unknown => {
                return value;
              })(value["custom"]),
              defaultFilterAllLanguages: ((value: boolean): unknown => {
                return value;
              })(value["defaultFilterAllLanguages"]),
              embedSortingFiltering: ((value: boolean): unknown => {
                return value;
              })(value["embedSortingFiltering"]),
              hideTitle: ((value: boolean): unknown => {
                return value;
              })(value["hideTitle"]),
              itemCount: ((value: number): unknown => {
                return value;
              })(value["itemCount"]),
              itemLayout: ((value: "MINI" | "REGULAR"): unknown => {
                return value;
              })(value["itemLayout"]),
              name: ((value: string): unknown => {
                return value;
              })(value["name"]),
              portletId: ((value: number): unknown => {
                return value;
              })(value["portletId"]),
              portletLayout: ((value: "GRID" | "CAROUSEL"): unknown => {
                return value;
              })(value["portletLayout"]),
              subType: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["subType"]),
              subtitle: ((value: string): unknown => {
                return value;
              })(value["subtitle"]),
              title: ((value: string): unknown => {
                return value;
              })(value["title"]),
              type: ((
                value:
                  | "IMAGETEXT"
                  | "SUMMARYLIST"
                  | "TRENDINGCHANNEL"
                  | "FEATUREDCHANNEL"
                  | "FOLLOWINGCHANNEL"
                  | "MYLIST"
                  | "PRIMARYTOPICCHANNEL"
                  | "CHANNELLIST"
                  | "ANNOTATIONLIST"
                  | "LGXPLIST"
                  | "SKETCHNOTESLGXP"
                  | "ACTIONABLELIST"
                  | "ACTIONABLELISTCUSTOM"
                  | "MYACTIONABLES"
                  | "FREESUMMARY"
                  | "SUMMARYLISTCUSTOM"
                  | "CUSTOMPAGELIST"
                  | "PROMOBOXCONFIG"
                  | "MYMIABS"
                  | "ASKGETABSTRACT"
                  | "CUSTOMIZEDMIABS"
                  | "MIABLIST"
                  | "UPCOMINGEXPERTVIDEOS",
              ): unknown => {
                return value;
              })(value["type"]),
            };
          },
        );
      })(value["customPortlets"]),
      customized: ((value: boolean): unknown => {
        return value;
      })(value["customized"]),
      defaultPortlets: ((value: PortletMetadata[]): unknown => {
        return value.map(
          (value: {
            custom: boolean;
            defaultFilterAllLanguages: boolean;
            embedSortingFiltering: boolean;
            hideTitle: boolean;
            itemCount: number;
            itemLayout: ItemLayout;
            name: string;
            portletId: number;
            portletLayout: PortletLayout;
            subType: string | null;
            subtitle: string;
            title: string;
            type: PortletType;
          }): unknown => {
            return {
              custom: ((value: boolean): unknown => {
                return value;
              })(value["custom"]),
              defaultFilterAllLanguages: ((value: boolean): unknown => {
                return value;
              })(value["defaultFilterAllLanguages"]),
              embedSortingFiltering: ((value: boolean): unknown => {
                return value;
              })(value["embedSortingFiltering"]),
              hideTitle: ((value: boolean): unknown => {
                return value;
              })(value["hideTitle"]),
              itemCount: ((value: number): unknown => {
                return value;
              })(value["itemCount"]),
              itemLayout: ((value: "MINI" | "REGULAR"): unknown => {
                return value;
              })(value["itemLayout"]),
              name: ((value: string): unknown => {
                return value;
              })(value["name"]),
              portletId: ((value: number): unknown => {
                return value;
              })(value["portletId"]),
              portletLayout: ((value: "GRID" | "CAROUSEL"): unknown => {
                return value;
              })(value["portletLayout"]),
              subType: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["subType"]),
              subtitle: ((value: string): unknown => {
                return value;
              })(value["subtitle"]),
              title: ((value: string): unknown => {
                return value;
              })(value["title"]),
              type: ((
                value:
                  | "IMAGETEXT"
                  | "SUMMARYLIST"
                  | "TRENDINGCHANNEL"
                  | "FEATUREDCHANNEL"
                  | "FOLLOWINGCHANNEL"
                  | "MYLIST"
                  | "PRIMARYTOPICCHANNEL"
                  | "CHANNELLIST"
                  | "ANNOTATIONLIST"
                  | "LGXPLIST"
                  | "SKETCHNOTESLGXP"
                  | "ACTIONABLELIST"
                  | "ACTIONABLELISTCUSTOM"
                  | "MYACTIONABLES"
                  | "FREESUMMARY"
                  | "SUMMARYLISTCUSTOM"
                  | "CUSTOMPAGELIST"
                  | "PROMOBOXCONFIG"
                  | "MYMIABS"
                  | "ASKGETABSTRACT"
                  | "CUSTOMIZEDMIABS"
                  | "MIABLIST"
                  | "UPCOMINGEXPERTVIDEOS",
              ): unknown => {
                return value;
              })(value["type"]),
            };
          },
        );
      })(value["defaultPortlets"]),
      language: ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
        return value;
      })(value["language"]),
      portletContainerId: ((value: number): unknown => {
        return value;
      })(value["portletContainerId"]),
      showDefaults: ((value: boolean): unknown => {
        return value;
      })(value["showDefaults"]),
      status: ((value: "DRAFT" | "LIVE"): unknown => {
        return value;
      })(value["status"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_PortletContainerAdminEditView(str: string): ParserResult<PortletContainerAdminEditView> {
  return ((
    value: unknown,
  ): ParserResult<{
    customPortlets: PortletMetadata[];
    customized: boolean;
    defaultPortlets: PortletMetadata[];
    language: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr";
    portletContainerId: number;
    showDefaults: boolean;
    status: PortletContainerStatus;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "customPortlets")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/customPortlets]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customPortlets'.` };
    }
    const parsed_customPortlets = ((): ParserResult<PortletMetadata[]> => {
      return ((value: unknown): ParserResult<PortletMetadata[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/customPortlets]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<PortletMetadata> => {
          return ((
            value: unknown,
          ): ParserResult<{
            custom: boolean;
            defaultFilterAllLanguages: boolean;
            embedSortingFiltering: boolean;
            hideTitle: boolean;
            itemCount: number;
            itemLayout: ItemLayout;
            name: string;
            portletId: number;
            portletLayout: PortletLayout;
            subType: string | null;
            subtitle: string;
            title: string;
            type: PortletType;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/PortletMetadata]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "custom")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/custom]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'custom'.` };
            }
            const parsed_custom = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/custom]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["custom"]);
            })();
            if (!parsed_custom.success) {
              return { success: false, reason: parsed_custom.reason };
            }
            if (!hasProp(value, "defaultFilterAllLanguages")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/defaultFilterAllLanguages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'defaultFilterAllLanguages'.` };
            }
            const parsed_defaultFilterAllLanguages = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/defaultFilterAllLanguages]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["defaultFilterAllLanguages"]);
            })();
            if (!parsed_defaultFilterAllLanguages.success) {
              return { success: false, reason: parsed_defaultFilterAllLanguages.reason };
            }
            if (!hasProp(value, "embedSortingFiltering")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/embedSortingFiltering]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'embedSortingFiltering'.` };
            }
            const parsed_embedSortingFiltering = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/embedSortingFiltering]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["embedSortingFiltering"]);
            })();
            if (!parsed_embedSortingFiltering.success) {
              return { success: false, reason: parsed_embedSortingFiltering.reason };
            }
            if (!hasProp(value, "hideTitle")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/hideTitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'hideTitle'.` };
            }
            const parsed_hideTitle = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/hideTitle]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["hideTitle"]);
            })();
            if (!parsed_hideTitle.success) {
              return { success: false, reason: parsed_hideTitle.reason };
            }
            if (!hasProp(value, "itemCount")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/itemCount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'itemCount'.` };
            }
            const parsed_itemCount = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/PortletMetadata/itemCount]: '${value}' expected to be of type number.` };
              })(value["itemCount"]);
            })();
            if (!parsed_itemCount.success) {
              return { success: false, reason: parsed_itemCount.reason };
            }
            if (!hasProp(value, "itemLayout")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/itemLayout]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'itemLayout'.` };
            }
            const parsed_itemLayout = ((): ParserResult<ItemLayout> => {
              return ((value: unknown): ParserResult<ItemLayout> => {
                return ((value: unknown): ParserResult<"MINI" | "REGULAR"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/ItemLayout]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "MINI":
                      return { success: true, value: "MINI" };
                    case "REGULAR":
                      return { success: true, value: "REGULAR" };
                    default:
                      return { success: false, reason: `[#/components/schemas/ItemLayout]: '${value}' expected to be enum, one of 'MINI, REGULAR'.` };
                  }
                })(value);
              })(value["itemLayout"]);
            })();
            if (!parsed_itemLayout.success) {
              return { success: false, reason: parsed_itemLayout.reason };
            }
            if (!hasProp(value, "name")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
            }
            const parsed_name = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/name]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["name"]);
            })();
            if (!parsed_name.success) {
              return { success: false, reason: parsed_name.reason };
            }
            if (!hasProp(value, "portletId")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/portletId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'portletId'.` };
            }
            const parsed_portletId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/PortletMetadata/portletId]: '${value}' expected to be of type number.` };
              })(value["portletId"]);
            })();
            if (!parsed_portletId.success) {
              return { success: false, reason: parsed_portletId.reason };
            }
            if (!hasProp(value, "portletLayout")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/portletLayout]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'portletLayout'.` };
            }
            const parsed_portletLayout = ((): ParserResult<PortletLayout> => {
              return ((value: unknown): ParserResult<PortletLayout> => {
                return ((value: unknown): ParserResult<"GRID" | "CAROUSEL"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/PortletLayout]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "GRID":
                      return { success: true, value: "GRID" };
                    case "CAROUSEL":
                      return { success: true, value: "CAROUSEL" };
                    default:
                      return { success: false, reason: `[#/components/schemas/PortletLayout]: '${value}' expected to be enum, one of 'GRID, CAROUSEL'.` };
                  }
                })(value);
              })(value["portletLayout"]);
            })();
            if (!parsed_portletLayout.success) {
              return { success: false, reason: parsed_portletLayout.reason };
            }
            if (!hasProp(value, "subType")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/subType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subType'.` };
            }
            const parsed_subType = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/subType]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["subType"]);
            })();
            if (!parsed_subType.success) {
              return { success: false, reason: parsed_subType.reason };
            }
            if (!hasProp(value, "subtitle")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/subtitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subtitle'.` };
            }
            const parsed_subtitle = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/subtitle]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["subtitle"]);
            })();
            if (!parsed_subtitle.success) {
              return { success: false, reason: parsed_subtitle.reason };
            }
            if (!hasProp(value, "title")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
            }
            const parsed_title = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/title]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["title"]);
            })();
            if (!parsed_title.success) {
              return { success: false, reason: parsed_title.reason };
            }
            if (!hasProp(value, "type")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
            }
            const parsed_type = ((): ParserResult<PortletType> => {
              return ((value: unknown): ParserResult<PortletType> => {
                return ((
                  value: unknown,
                ): ParserResult<
                  | "IMAGETEXT"
                  | "SUMMARYLIST"
                  | "TRENDINGCHANNEL"
                  | "FEATUREDCHANNEL"
                  | "FOLLOWINGCHANNEL"
                  | "MYLIST"
                  | "PRIMARYTOPICCHANNEL"
                  | "CHANNELLIST"
                  | "ANNOTATIONLIST"
                  | "LGXPLIST"
                  | "SKETCHNOTESLGXP"
                  | "ACTIONABLELIST"
                  | "ACTIONABLELISTCUSTOM"
                  | "MYACTIONABLES"
                  | "FREESUMMARY"
                  | "SUMMARYLISTCUSTOM"
                  | "CUSTOMPAGELIST"
                  | "PROMOBOXCONFIG"
                  | "MYMIABS"
                  | "ASKGETABSTRACT"
                  | "CUSTOMIZEDMIABS"
                  | "MIABLIST"
                  | "UPCOMINGEXPERTVIDEOS"
                > => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/PortletType]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "IMAGETEXT":
                      return { success: true, value: "IMAGETEXT" };
                    case "SUMMARYLIST":
                      return { success: true, value: "SUMMARYLIST" };
                    case "TRENDINGCHANNEL":
                      return { success: true, value: "TRENDINGCHANNEL" };
                    case "FEATUREDCHANNEL":
                      return { success: true, value: "FEATUREDCHANNEL" };
                    case "FOLLOWINGCHANNEL":
                      return { success: true, value: "FOLLOWINGCHANNEL" };
                    case "MYLIST":
                      return { success: true, value: "MYLIST" };
                    case "PRIMARYTOPICCHANNEL":
                      return { success: true, value: "PRIMARYTOPICCHANNEL" };
                    case "CHANNELLIST":
                      return { success: true, value: "CHANNELLIST" };
                    case "ANNOTATIONLIST":
                      return { success: true, value: "ANNOTATIONLIST" };
                    case "LGXPLIST":
                      return { success: true, value: "LGXPLIST" };
                    case "SKETCHNOTESLGXP":
                      return { success: true, value: "SKETCHNOTESLGXP" };
                    case "ACTIONABLELIST":
                      return { success: true, value: "ACTIONABLELIST" };
                    case "ACTIONABLELISTCUSTOM":
                      return { success: true, value: "ACTIONABLELISTCUSTOM" };
                    case "MYACTIONABLES":
                      return { success: true, value: "MYACTIONABLES" };
                    case "FREESUMMARY":
                      return { success: true, value: "FREESUMMARY" };
                    case "SUMMARYLISTCUSTOM":
                      return { success: true, value: "SUMMARYLISTCUSTOM" };
                    case "CUSTOMPAGELIST":
                      return { success: true, value: "CUSTOMPAGELIST" };
                    case "PROMOBOXCONFIG":
                      return { success: true, value: "PROMOBOXCONFIG" };
                    case "MYMIABS":
                      return { success: true, value: "MYMIABS" };
                    case "ASKGETABSTRACT":
                      return { success: true, value: "ASKGETABSTRACT" };
                    case "CUSTOMIZEDMIABS":
                      return { success: true, value: "CUSTOMIZEDMIABS" };
                    case "MIABLIST":
                      return { success: true, value: "MIABLIST" };
                    case "UPCOMINGEXPERTVIDEOS":
                      return { success: true, value: "UPCOMINGEXPERTVIDEOS" };
                    default:
                      return {
                        success: false,
                        reason: `[#/components/schemas/PortletType]: '${value}' expected to be enum, one of 'IMAGETEXT, SUMMARYLIST, TRENDINGCHANNEL, FEATUREDCHANNEL, FOLLOWINGCHANNEL, MYLIST, PRIMARYTOPICCHANNEL, CHANNELLIST, ANNOTATIONLIST, LGXPLIST, SKETCHNOTESLGXP, ACTIONABLELIST, ACTIONABLELISTCUSTOM, MYACTIONABLES, FREESUMMARY, SUMMARYLISTCUSTOM, CUSTOMPAGELIST, PROMOBOXCONFIG, MYMIABS, ASKGETABSTRACT, CUSTOMIZEDMIABS, MIABLIST, UPCOMINGEXPERTVIDEOS'.`,
                      };
                  }
                })(value);
              })(value["type"]);
            })();
            if (!parsed_type.success) {
              return { success: false, reason: parsed_type.reason };
            }
            return {
              success: true,
              value: {
                custom: parsed_custom.value,
                defaultFilterAllLanguages: parsed_defaultFilterAllLanguages.value,
                embedSortingFiltering: parsed_embedSortingFiltering.value,
                hideTitle: parsed_hideTitle.value,
                itemCount: parsed_itemCount.value,
                itemLayout: parsed_itemLayout.value,
                name: parsed_name.value,
                portletId: parsed_portletId.value,
                portletLayout: parsed_portletLayout.value,
                subType: parsed_subType.value,
                subtitle: parsed_subtitle.value,
                title: parsed_title.value,
                type: parsed_type.value,
              },
            };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/PortletContainerAdminEditView/customPortlets]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["customPortlets"]);
    })();
    if (!parsed_customPortlets.success) {
      return { success: false, reason: parsed_customPortlets.reason };
    }
    if (!hasProp(value, "customized")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/customized]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customized'.` };
    }
    const parsed_customized = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/customized]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["customized"]);
    })();
    if (!parsed_customized.success) {
      return { success: false, reason: parsed_customized.reason };
    }
    if (!hasProp(value, "defaultPortlets")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/defaultPortlets]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'defaultPortlets'.` };
    }
    const parsed_defaultPortlets = ((): ParserResult<PortletMetadata[]> => {
      return ((value: unknown): ParserResult<PortletMetadata[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/defaultPortlets]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<PortletMetadata> => {
          return ((
            value: unknown,
          ): ParserResult<{
            custom: boolean;
            defaultFilterAllLanguages: boolean;
            embedSortingFiltering: boolean;
            hideTitle: boolean;
            itemCount: number;
            itemLayout: ItemLayout;
            name: string;
            portletId: number;
            portletLayout: PortletLayout;
            subType: string | null;
            subtitle: string;
            title: string;
            type: PortletType;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/PortletMetadata]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "custom")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/custom]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'custom'.` };
            }
            const parsed_custom = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/custom]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["custom"]);
            })();
            if (!parsed_custom.success) {
              return { success: false, reason: parsed_custom.reason };
            }
            if (!hasProp(value, "defaultFilterAllLanguages")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/defaultFilterAllLanguages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'defaultFilterAllLanguages'.` };
            }
            const parsed_defaultFilterAllLanguages = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/defaultFilterAllLanguages]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["defaultFilterAllLanguages"]);
            })();
            if (!parsed_defaultFilterAllLanguages.success) {
              return { success: false, reason: parsed_defaultFilterAllLanguages.reason };
            }
            if (!hasProp(value, "embedSortingFiltering")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/embedSortingFiltering]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'embedSortingFiltering'.` };
            }
            const parsed_embedSortingFiltering = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/embedSortingFiltering]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["embedSortingFiltering"]);
            })();
            if (!parsed_embedSortingFiltering.success) {
              return { success: false, reason: parsed_embedSortingFiltering.reason };
            }
            if (!hasProp(value, "hideTitle")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/hideTitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'hideTitle'.` };
            }
            const parsed_hideTitle = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/hideTitle]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["hideTitle"]);
            })();
            if (!parsed_hideTitle.success) {
              return { success: false, reason: parsed_hideTitle.reason };
            }
            if (!hasProp(value, "itemCount")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/itemCount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'itemCount'.` };
            }
            const parsed_itemCount = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/PortletMetadata/itemCount]: '${value}' expected to be of type number.` };
              })(value["itemCount"]);
            })();
            if (!parsed_itemCount.success) {
              return { success: false, reason: parsed_itemCount.reason };
            }
            if (!hasProp(value, "itemLayout")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/itemLayout]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'itemLayout'.` };
            }
            const parsed_itemLayout = ((): ParserResult<ItemLayout> => {
              return ((value: unknown): ParserResult<ItemLayout> => {
                return ((value: unknown): ParserResult<"MINI" | "REGULAR"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/ItemLayout]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "MINI":
                      return { success: true, value: "MINI" };
                    case "REGULAR":
                      return { success: true, value: "REGULAR" };
                    default:
                      return { success: false, reason: `[#/components/schemas/ItemLayout]: '${value}' expected to be enum, one of 'MINI, REGULAR'.` };
                  }
                })(value);
              })(value["itemLayout"]);
            })();
            if (!parsed_itemLayout.success) {
              return { success: false, reason: parsed_itemLayout.reason };
            }
            if (!hasProp(value, "name")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
            }
            const parsed_name = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/name]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["name"]);
            })();
            if (!parsed_name.success) {
              return { success: false, reason: parsed_name.reason };
            }
            if (!hasProp(value, "portletId")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/portletId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'portletId'.` };
            }
            const parsed_portletId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/PortletMetadata/portletId]: '${value}' expected to be of type number.` };
              })(value["portletId"]);
            })();
            if (!parsed_portletId.success) {
              return { success: false, reason: parsed_portletId.reason };
            }
            if (!hasProp(value, "portletLayout")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/portletLayout]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'portletLayout'.` };
            }
            const parsed_portletLayout = ((): ParserResult<PortletLayout> => {
              return ((value: unknown): ParserResult<PortletLayout> => {
                return ((value: unknown): ParserResult<"GRID" | "CAROUSEL"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/PortletLayout]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "GRID":
                      return { success: true, value: "GRID" };
                    case "CAROUSEL":
                      return { success: true, value: "CAROUSEL" };
                    default:
                      return { success: false, reason: `[#/components/schemas/PortletLayout]: '${value}' expected to be enum, one of 'GRID, CAROUSEL'.` };
                  }
                })(value);
              })(value["portletLayout"]);
            })();
            if (!parsed_portletLayout.success) {
              return { success: false, reason: parsed_portletLayout.reason };
            }
            if (!hasProp(value, "subType")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/subType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subType'.` };
            }
            const parsed_subType = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/subType]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["subType"]);
            })();
            if (!parsed_subType.success) {
              return { success: false, reason: parsed_subType.reason };
            }
            if (!hasProp(value, "subtitle")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/subtitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subtitle'.` };
            }
            const parsed_subtitle = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/subtitle]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["subtitle"]);
            })();
            if (!parsed_subtitle.success) {
              return { success: false, reason: parsed_subtitle.reason };
            }
            if (!hasProp(value, "title")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
            }
            const parsed_title = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/PortletMetadata/title]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["title"]);
            })();
            if (!parsed_title.success) {
              return { success: false, reason: parsed_title.reason };
            }
            if (!hasProp(value, "type")) {
              return { success: false, reason: `[#/components/schemas/PortletMetadata/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
            }
            const parsed_type = ((): ParserResult<PortletType> => {
              return ((value: unknown): ParserResult<PortletType> => {
                return ((
                  value: unknown,
                ): ParserResult<
                  | "IMAGETEXT"
                  | "SUMMARYLIST"
                  | "TRENDINGCHANNEL"
                  | "FEATUREDCHANNEL"
                  | "FOLLOWINGCHANNEL"
                  | "MYLIST"
                  | "PRIMARYTOPICCHANNEL"
                  | "CHANNELLIST"
                  | "ANNOTATIONLIST"
                  | "LGXPLIST"
                  | "SKETCHNOTESLGXP"
                  | "ACTIONABLELIST"
                  | "ACTIONABLELISTCUSTOM"
                  | "MYACTIONABLES"
                  | "FREESUMMARY"
                  | "SUMMARYLISTCUSTOM"
                  | "CUSTOMPAGELIST"
                  | "PROMOBOXCONFIG"
                  | "MYMIABS"
                  | "ASKGETABSTRACT"
                  | "CUSTOMIZEDMIABS"
                  | "MIABLIST"
                  | "UPCOMINGEXPERTVIDEOS"
                > => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/PortletType]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "IMAGETEXT":
                      return { success: true, value: "IMAGETEXT" };
                    case "SUMMARYLIST":
                      return { success: true, value: "SUMMARYLIST" };
                    case "TRENDINGCHANNEL":
                      return { success: true, value: "TRENDINGCHANNEL" };
                    case "FEATUREDCHANNEL":
                      return { success: true, value: "FEATUREDCHANNEL" };
                    case "FOLLOWINGCHANNEL":
                      return { success: true, value: "FOLLOWINGCHANNEL" };
                    case "MYLIST":
                      return { success: true, value: "MYLIST" };
                    case "PRIMARYTOPICCHANNEL":
                      return { success: true, value: "PRIMARYTOPICCHANNEL" };
                    case "CHANNELLIST":
                      return { success: true, value: "CHANNELLIST" };
                    case "ANNOTATIONLIST":
                      return { success: true, value: "ANNOTATIONLIST" };
                    case "LGXPLIST":
                      return { success: true, value: "LGXPLIST" };
                    case "SKETCHNOTESLGXP":
                      return { success: true, value: "SKETCHNOTESLGXP" };
                    case "ACTIONABLELIST":
                      return { success: true, value: "ACTIONABLELIST" };
                    case "ACTIONABLELISTCUSTOM":
                      return { success: true, value: "ACTIONABLELISTCUSTOM" };
                    case "MYACTIONABLES":
                      return { success: true, value: "MYACTIONABLES" };
                    case "FREESUMMARY":
                      return { success: true, value: "FREESUMMARY" };
                    case "SUMMARYLISTCUSTOM":
                      return { success: true, value: "SUMMARYLISTCUSTOM" };
                    case "CUSTOMPAGELIST":
                      return { success: true, value: "CUSTOMPAGELIST" };
                    case "PROMOBOXCONFIG":
                      return { success: true, value: "PROMOBOXCONFIG" };
                    case "MYMIABS":
                      return { success: true, value: "MYMIABS" };
                    case "ASKGETABSTRACT":
                      return { success: true, value: "ASKGETABSTRACT" };
                    case "CUSTOMIZEDMIABS":
                      return { success: true, value: "CUSTOMIZEDMIABS" };
                    case "MIABLIST":
                      return { success: true, value: "MIABLIST" };
                    case "UPCOMINGEXPERTVIDEOS":
                      return { success: true, value: "UPCOMINGEXPERTVIDEOS" };
                    default:
                      return {
                        success: false,
                        reason: `[#/components/schemas/PortletType]: '${value}' expected to be enum, one of 'IMAGETEXT, SUMMARYLIST, TRENDINGCHANNEL, FEATUREDCHANNEL, FOLLOWINGCHANNEL, MYLIST, PRIMARYTOPICCHANNEL, CHANNELLIST, ANNOTATIONLIST, LGXPLIST, SKETCHNOTESLGXP, ACTIONABLELIST, ACTIONABLELISTCUSTOM, MYACTIONABLES, FREESUMMARY, SUMMARYLISTCUSTOM, CUSTOMPAGELIST, PROMOBOXCONFIG, MYMIABS, ASKGETABSTRACT, CUSTOMIZEDMIABS, MIABLIST, UPCOMINGEXPERTVIDEOS'.`,
                      };
                  }
                })(value);
              })(value["type"]);
            })();
            if (!parsed_type.success) {
              return { success: false, reason: parsed_type.reason };
            }
            return {
              success: true,
              value: {
                custom: parsed_custom.value,
                defaultFilterAllLanguages: parsed_defaultFilterAllLanguages.value,
                embedSortingFiltering: parsed_embedSortingFiltering.value,
                hideTitle: parsed_hideTitle.value,
                itemCount: parsed_itemCount.value,
                itemLayout: parsed_itemLayout.value,
                name: parsed_name.value,
                portletId: parsed_portletId.value,
                portletLayout: parsed_portletLayout.value,
                subType: parsed_subType.value,
                subtitle: parsed_subtitle.value,
                title: parsed_title.value,
                type: parsed_type.value,
              },
            };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/PortletContainerAdminEditView/defaultPortlets]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["defaultPortlets"]);
    })();
    if (!parsed_defaultPortlets.success) {
      return { success: false, reason: parsed_defaultPortlets.reason };
    }
    if (!hasProp(value, "language")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
    }
    const parsed_language = ((): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
      return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/language]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "en":
            return { success: true, value: "en" };
          case "de":
            return { success: true, value: "de" };
          case "es":
            return { success: true, value: "es" };
          case "ru":
            return { success: true, value: "ru" };
          case "zh":
            return { success: true, value: "zh" };
          case "pt":
            return { success: true, value: "pt" };
          case "fr":
            return { success: true, value: "fr" };
          default:
            return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
        }
      })(value["language"]);
    })();
    if (!parsed_language.success) {
      return { success: false, reason: parsed_language.reason };
    }
    if (!hasProp(value, "portletContainerId")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/portletContainerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'portletContainerId'.` };
    }
    const parsed_portletContainerId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/portletContainerId]: '${value}' expected to be of type number.` };
      })(value["portletContainerId"]);
    })();
    if (!parsed_portletContainerId.success) {
      return { success: false, reason: parsed_portletContainerId.reason };
    }
    if (!hasProp(value, "showDefaults")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/showDefaults]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'showDefaults'.` };
    }
    const parsed_showDefaults = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/showDefaults]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["showDefaults"]);
    })();
    if (!parsed_showDefaults.success) {
      return { success: false, reason: parsed_showDefaults.reason };
    }
    if (!hasProp(value, "status")) {
      return { success: false, reason: `[#/components/schemas/PortletContainerAdminEditView/status]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'status'.` };
    }
    const parsed_status = ((): ParserResult<PortletContainerStatus> => {
      return ((value: unknown): ParserResult<PortletContainerStatus> => {
        return ((value: unknown): ParserResult<"DRAFT" | "LIVE"> => {
          if (typeof value !== "string") {
            return { success: false, reason: `[#/components/schemas/PortletContainerStatus]: '${value}' expected to be of type string.` };
          }
          switch (value) {
            case "DRAFT":
              return { success: true, value: "DRAFT" };
            case "LIVE":
              return { success: true, value: "LIVE" };
            default:
              return { success: false, reason: `[#/components/schemas/PortletContainerStatus]: '${value}' expected to be enum, one of 'DRAFT, LIVE'.` };
          }
        })(value);
      })(value["status"]);
    })();
    if (!parsed_status.success) {
      return { success: false, reason: parsed_status.reason };
    }
    return {
      success: true,
      value: {
        customPortlets: parsed_customPortlets.value,
        customized: parsed_customized.value,
        defaultPortlets: parsed_defaultPortlets.value,
        language: parsed_language.value,
        portletContainerId: parsed_portletContainerId.value,
        showDefaults: parsed_showDefaults.value,
        status: parsed_status.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
